import * as React from 'react'
import { customerMarketShopfrontApi } from '@envato/foundation-types'
import Button, { ButtonAppearance, ButtonSize } from '@envato/foundation-button'

import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import { ICategoryPageBlockComponent } from '../../../../typings/pageBlocks'
import { IItem } from '../../../../typings/searchResults'
import ItemCard from '../../itemCard'
import ItemCardsLayout from '../../itemCardsLayout'

import * as styles from './promoItemsBlock.module.css'

interface IProps extends ICategoryPageBlockComponent {
  data: IItem[]
  title: string
  subtitle?: string
  cta?: customerMarketShopfrontApi.categoryPage.ICta
  componentType: string
}

const PromoItemsBlock = ({
  title,
  subtitle,
  cta,
  data,
  componentType
}: IProps) => {
  return (
    <section className={styles.root}>
      <div className={styles.promoItemsBlockWrapper}>
        <ItemCardsLayout viewType="grid">
          <ItemCardsLayout.CardArea className={styles.promoItem}>
            <div className={styles.campaignTextWrapper}>
              <header>
                <h2 className={styles.title}>{title}</h2>
                {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
              </header>

              {cta && (
                <Button
                  className={styles.button}
                  appearance={ButtonAppearance.Primary}
                  onClick={() =>
                    reportBlockClick(componentType, {
                      eventLabel: cta.title
                    })
                  }
                  size={ButtonSize.Small}
                  href={cta.url}
                >
                  {cta.title}
                </Button>
              )}
            </div>
          </ItemCardsLayout.CardArea>
          {data.map((item, index) => (
            <ItemCardsLayout.CardArea key={item.id}>
              <ItemCard
                listName="Category page"
                item={item}
                index={index}
                viewType="grid"
              />
            </ItemCardsLayout.CardArea>
          ))}
        </ItemCardsLayout>
      </div>
    </section>
  )
}

export default PromoItemsBlock
